import {
  createUnitTypeOptions,
  WORKING_DECLARATION_LABEL_KEYS,
} from '@/config/unitTypes.constants';

export const { unitTypeLabel, buildRowUnitOptions, buildUnitHeaderOptions } = createUnitTypeOptions(
  WORKING_DECLARATION_LABEL_KEYS,
);
